export default "__VITE_ASSET__3a39c094__"